import { createContext, useContext } from 'react';

import type { TrackedSkillFragment } from 'bundles/page-config-common/queries/__generated__/QueryAdminSelectedSkills';
import type { SkillsProgress_SkillProgressFragment as SkillsProgressV2 } from 'bundles/page-config-common/queries/__generated__/SkillsProgress_SkillProgress';

export type EnterpriseOrgScopedSkillsContextType = {
  skillLimit?: number;
  latestSkillsWithProgress?: SkillsProgressV2[];
  hasSkillProgress?: boolean;
  areLatestSkillsLoading?: boolean;
  totalLatestSkills?: number;
  hasProgramSpecificSkills?: boolean;
  adminSelectedSkills?: TrackedSkillFragment[];
  areAdminSelectedSkillsLoading?: boolean;
  hasError: boolean;
};

const EnterpriseOrgScopedSkillsContext = createContext<EnterpriseOrgScopedSkillsContextType>({
  latestSkillsWithProgress: [],
  hasSkillProgress: false,
  areLatestSkillsLoading: true,
  totalLatestSkills: 0,
  hasProgramSpecificSkills: false,
  adminSelectedSkills: [],
  areAdminSelectedSkillsLoading: true,
  hasError: false,
});

/**
 * @description Hook used to access the current enterprise skills and their progress
 */
export const useEnterpriseOrgScopedSkills = () => useContext(EnterpriseOrgScopedSkillsContext);

export default EnterpriseOrgScopedSkillsContext;
